'use client';
import { Flex } from '@osmosis/tailwind-ui/components/Box';
import { Icon } from '@osmosis/tailwind-ui/components/Icon';
import { P } from '@osmosis/tailwind-ui/components/Text';
import React, { CSSProperties } from 'react';

import { faGlobe } from '@fortawesome/pro-solid-svg-icons/faGlobe';
import { useLanguageContext } from '../context/LanguageProvider';

type Props = {
  size?: number;
  containerSx?: CSSProperties;
  className?: string;
};

/**
 * .
 */
const LanguageTag = (props: Props) => {
  const { size = 16, containerSx = {}, className = '' } = props;

  const { isEnglish } = useLanguageContext();

  const text = 'en inglés';

  return !isEnglish ? (
    <Flex
      style={{
        ...containerSx,
      }}
      className={`rounded gap-2 items-center text-[${size}px] leading-[1.5] bg-[#bfd9f2] dark:bg-gray-200 py-[0.4em] px-[0.75em] text-blue-800 dark:text-white ${className}`}
    >
      <Flex className={`items-center !text-[length:inherit]`}>
        <Icon icon={faGlobe} />
      </Flex>
      <P className={`font-bold !text-[length:inherit] !leading-[inherit]`}>
        {text}
      </P>
    </Flex>
  ) : (
    <></>
  );
};

export default LanguageTag;
